module.exports = __webpack_public_path__ + "img/2-刷新.04e8dc34.svg";